module.exports = __webpack_public_path__ + "static/media/trim-ph-t.2097a2fe.png";